import React,{ useState, useEffect } from 'react';
import { FormControl } from '@material-ui/core';
import { CustomLabel, CustomOptions }  from "@tracknme/material-ui";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import '../../App.css';
import '../../menu.css';

function Step3() {

  const dispatch = useDispatch();
  
  const { register,navigation } = useSelector(({register}) => register);

  const [options1,setOptions1] = useState(false);
  const [options2,setOptions2] = useState(false);
  const [options3,setOptions3] = useState(false);
  const [options4,setOptions4] = useState(false);
  const [tos,setTos] = useState(false);
  const [loadData,setLoadData] = useState(false);
  
  useEffect(() => {

    if(!loadData && register && register.brand && register.brand.purposeOfUse &&  register.brand.purposeOfUse.length > 0){

      register.brand.purposeOfUse.forEach(purpose => {

        if(purpose === "Revenda de Rastreadores"){
          setOptions1(true)
        }
        if(purpose === "Plataforma de Rastreamento"){
          setOptions2(true)
        }
        if(purpose === "Gerenciamento de Clientes"){
          setOptions3(true)
        }
        if(purpose === "Outros"){
          setOptions4(true)
        }
        
      });

      setTos(true)
      setLoadData(true)

    }

  }, [loadData,register ]);

  function changeOptions1Value (event){
   setOptions1(options1 ? false : true)
  }
  function changeOptions2Value (){
    setOptions2(options2 ? false : true)
  }
  function changeOptions3Value (){
    setOptions3(options3 ? false : true)
  }
  function changeOptions4Value (){
    setOptions4(options4 ? false : true)
  }
  function changeTosValue (){
    setTos(tos ? false : true)
  }

  function changeButtonValue (){
    window.open("https://site.tracknme.com.br/politica_privacidade/");
  }

  useEffect(() => {
    
    if(tos  &&(options1 || options2 || options3 || options4)){
    
      dispatch(Actions.setNavigation(false));
      
      let purposeOfUse = [];

      if(options1){
        purposeOfUse.push("Revenda de Rastreadores")
      }
      if(options2){
        purposeOfUse.push("Plataforma de Rastreamento")
      }
      if(options3){
        purposeOfUse.push("Gerenciamento de Clientes")
      }
      if(options4){
        purposeOfUse.push("Outros")
      }

      let _register = register ? register : {brand:{'purposeOfUse':[]}};

      if(_register){
        _register['brand']['purposeOfUse'] = purposeOfUse;
      }
         
      dispatch(Actions.setRegister(_register));
      
    }else if(!navigation){
      dispatch(Actions.setNavigation(true));
    }
  }, [tos, options1, options2, options3, options4,register, navigation,dispatch]);


  

  return (
    
        <div>
             <div className="titleStep1">
                <CustomLabel id="standard-basic-data-picker" label="Você está procurando uma solução para qual finalidade?" color="initial" component="h6" variant="h6" style={{fontSize:'2.5vh', fontWeight:'bold', color:"#4D39E9"}} />  
            </div>

            <div className="form_top_step3">
                    <div className="conteudo_step3">
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false} >
                    <CustomOptions  id="options1" label="Revenda de Rastreadores"  name="options1" border={false} checked={options1} handleChange={changeOptions1Value} style={{width:'25vw', backgroundColor:'white', height:46}}/>   
                  </FormControl>  
                  
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false} >
                    <CustomOptions  id="options2" label="Plataforma de Rastreamento"  name="options2" checked={options2} border={false} handleChange={changeOptions2Value} style={{width:'25vw', backgroundColor:'white', height:46}}/>   
                  </FormControl>  
                  </div>
            </div>

            <div className="form_bottom_step3">
                    <div className="conteudo_bottom_step3">
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false} >
                    <CustomOptions  id="options3" label="Gerenciamento de Clientes"  name="options3" checked={options3} border={false} handleChange={changeOptions3Value} style={{width:'25vw', backgroundColor:'white', height:46}}/>   
                  </FormControl>  
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false} >
                    <CustomOptions  id="options4" label="Outros"  name="options4" border={false} checked={options4} handleChange={changeOptions4Value} style={{width:'25vw', backgroundColor:'white', height:46}}/>   
                  </FormControl>  
                  </div>
            </div>

            <div className="form_step3">
                    <div className="conteudo_top_step3">
                <div className="styleContainer">
                  <CustomOptions  id="options" label=""  name="options" border={false} checked={tos} handleChange={changeTosValue} style={{width:30, backgroundColor:'transparent', height:46, color:'black'}}/> 
                  <CustomLabel id="standard-basic-data-picker" label="Li e concordo com os " color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'400', color:"black"}} /> 
                  <div className="pointer" onClick={() => changeButtonValue()}>
                    <CustomLabel id="standard-basic-data-picker" label=" termos de uso." color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'400', color:"orange", marginLeft:'5px'}} />
                  </div>
                </div>
                </div>
            </div>
                   
        </div>
  );
}

export default Step3;

